import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../ui/select';
import { Microphone } from '@phosphor-icons/react';
import { Loader2 } from 'lucide-react';

export function QuickTextMode({
  chantierId, onChantierChange, chantiers,
  isProcessing, onSave, onCancel, onSwitchToVoice,
}) {
  const [text, setText] = useState('');
  const canSave = !!(text.trim() && chantierId);

  return (
    <div className="py-4 space-y-4">
      <div>
        <Label>Chantier <span className="text-red-500">*</span></Label>
        <Select value={chantierId} onValueChange={onChantierChange}>
          <SelectTrigger className="mt-1 h-12 text-base" data-testid="quick-text-chantier">
            <SelectValue placeholder="Sélectionner un chantier (obligatoire)" />
          </SelectTrigger>
          <SelectContent position="popper" className="z-[100]">
            {chantiers.map(c => (
              <SelectItem key={c.id} value={c.id} className="py-3">{c.name}</SelectItem>
            ))}
          </SelectContent>
        </Select>
        {!chantierId && (
          <p className="text-xs text-red-600 mt-1">Le chantier est obligatoire — sans lui, la note ne sera visible nulle part.</p>
        )}
      </div>

      <div>
        <Label>Note</Label>
        <Textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Saisissez votre observation, remarque ou note de chantier..."
          className="mt-1 min-h-[120px] text-base resize-none"
          data-testid="quick-text-input"
          autoFocus
        />
      </div>

      <div className="flex gap-3">
        <Button
          onClick={() => onSave(text)}
          disabled={!canSave || isProcessing}
          className="flex-1 h-12 bg-[#FF6B00] hover:bg-orange-700 text-white font-semibold disabled:opacity-50"
          data-testid="quick-text-save"
        >
          {isProcessing ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
          Enregistrer
        </Button>
        <Button variant="outline" onClick={onCancel} className="h-12 px-6">
          Annuler
        </Button>
      </div>

      {onSwitchToVoice && (
        <button
          onClick={onSwitchToVoice}
          className="w-full flex items-center justify-center gap-2 py-2.5 text-sm font-medium text-[#FF6B00] hover:bg-orange-50 rounded-lg transition-colors"
          data-testid="switch-to-voice"
        >
          <Microphone size={18} weight="bold" />
          Passer en mode vocal
        </button>
      )}
    </div>
  );
}
